module.exports = __webpack_public_path__ + "static/media/tangopage.7c1f428d.png";